import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { AccessType } from "src/app/enums/access-type.enum";
import { ErrorType } from "src/app/enums/error-type.enum";
import { InputType } from "src/app/enums/input-type.enum";
import { LoginFormGroupModel } from "src/app/models/form-group.model";
import { LoginData, UserData } from "src/app/models/user-data.models";
import { ApiService } from "src/app/services/api.service";
import { EventService } from "src/app/services/event.service";
import { StorageService } from "src/app/services/storage.service";
import { fadeInUpAnimation } from "../../../../@fury/animations/fade-in-up.animation";
import { Subject } from "rxjs";
import { finalize, takeUntil } from "rxjs/operators";
import endpoints from "src/app/helpers/endpoints";

@Component({
  selector: "fury-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  animations: [fadeInUpAnimation],
})
export class LoginComponent implements OnInit, OnDestroy {
  loginForm!: FormGroup<LoginFormGroupModel>;
  inputType = InputType.Password;
  visible = false;
  ngUnSubscribe = new Subject<void>();
  isLoading = false;

  constructor(
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef,
    private storage: StorageService,
    private event: EventService,
    private apiService: ApiService
  ) { }

  ngOnInit() {
    this.formInit();
  }

  formInit() {
    this.loginForm = new FormGroup<LoginFormGroupModel>({
      emailAddress: new FormControl("", Validators.required),
      password: new FormControl("", Validators.required),
      rememberMe: new FormControl(false),
    });
  }

  login() {
    if (this.loginForm.valid) {
      this.isLoading = true;
      const data = this.loginForm.value;
      const value: LoginData = {
        emailAddress: data.emailAddress?.trim(),
        password: data.password?.trim(),
        rememberMe: data.rememberMe!,
      };
      this.apiService.post(endpoints.auth.login, value).pipe(finalize(()=> this.isLoading = false), takeUntil(this.ngUnSubscribe)).subscribe(
        (res: any) => {
          if (res.body?.data) {
            const user: UserData = {
              token: res.body.data._token,
              userName:
                res.body.data.user.firstName +
                " " +
                res.body.data.user.lastName,
              profileImage: res.body.data.user.profilePicture,
              access: AccessType.ContentManagement,
              email: res.body.data.user.emailAddress,
              rememberMe: data.rememberMe!,
              userId: res.body.data?.user.userId,
              isAdmin: res.body.data?.user?.newRole?.some((role: any) => role?.isAdmin),
              editorAccess: res.body?.data?.user?.editorAccess,
              activityStatus: res.body?.data?.user?.activityStatus,
              roleIds: res.body?.data?.user?.newRole?.map((role: any)=> role?.roleId),
              isSuperAdmin: !!res.body.data?.user?.specialAccess,
            };
            this.event.userData.next(user);
            this.apiService.alert(res.body.message, ErrorType.Success);
            this.storage.setUser(user);
            this.event.setLoginEmmit(true);
            this.router.navigate(["/"]);
          } else {
            this.apiService.alert(res.body.message, ErrorType.Warning);
          }
        },
        (err) => {
          if (err) {
            this.apiService.alert(err.message, ErrorType.Error);
          }
        }
      );
    } else {
      this.loginForm.markAllAsTouched();
    }
  }

  toggleVisibility() {
    if (this.visible) {
      this.inputType = InputType.Password;
      this.visible = false;
      this.changeDetectorRef.markForCheck();
    } else {
      this.inputType = InputType.Text;
      this.visible = true;
      this.changeDetectorRef.markForCheck();
    }
  }
  ngOnDestroy() {
    this.ngUnSubscribe.next();
    this.ngUnSubscribe.complete();
  }
}
